const styles = (theme) => ({
    reponsiveTable: {
        overflowX: 'scroll',
        overflowY: 'hidden',
    },
    table: {
        margin: '0 0 30px 0',
        backgroundColor: '#ffffff',
    },
    tableRow: {
        verticalAlign: 'middle',
    },
    headTableCell: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    addButton: {
        borderRadius: '30px',
        padding: '5px 20px',
        border: '1px solid #ccc',
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        backgroundColor: '#fff',
        alignItems: 'center',
        display: 'flex',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontFamily: theme.typography.fontFamily,
        float: 'right',
    },
    btnSigleAction: {
        minWidth: '30px',
        height: '30px',
        lineHeight: '30px',
        borderRadius: '50%',
        display: 'inline-flex',
        color: '#fff',
        marginRight: '5px',
        padding: '0',
        fontSize: '16px',
    },
    btnSignatureCompany: {
        color: '#6F6Fa9',
        '& img': {
            marginRight: '5px',
        },
    },
    btnSignature: {
        border: '1px solid #6F6Fa9',
        color: '#6F6Fa9',
        padding: '5px 20px',
        borderRadius: '10px',
        marginBottom: '40px',
        '& img': {
            marginRight: '5px',
        },
    },
    btnSignatureLine: {
        border: '1px solid #6F6Fa9',
        backgroundColor: '#fff',
        color: '#6F6Fa9',
        padding: '5px 20px',
        borderRadius: '10px',
        marginBottom: '0px',
        '& img': {
            marginRight: '5px',
        },
    },
    msgSignature: {
        display: 'flex',
        color: '#6F6Fa9',
        '& img': {
            marginRight: '5px',
        },
        alignItems: 'center',
    },
    centerProgress: {
        textAlign: 'center',
    },
    containerForm: {
        marginTop: '10px',
    },
    fieldsContainer: {
        overflow: 'hidden',
        paddingBottom: '0',
        '& h3': {
            fontWeight: 'bold',
            color: '#666',
            marginBottom: '5px',
        },
        '& p': {
            margin: '0',
        },
    },
    actionsContainer: {
        flex: 1,
        padding: '30px',
        margin: '30px 0 10px 0',
        display: 'flex',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    actionsBtns: {
        borderRadius: '20px',
        width: '190px',
        height: '40px',
    },
    textCenter: {
        textAlign: 'center',
    },
    progress: {
        margin: '25px 0 0 5px',
    },
    containerIcons: {
        display: 'flex',
    },
    btnActualFile: {
        borderRadius: '0px',
        textTransform: 'none',
        padding: '4px 10px',
        marginTop: '5px',
        marginBottom: '0px',
        marginRight: '10px',
    },
    btnDeleteFile: {
        display: 'block',
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        background: '#b6b6c3',
        color: '#fff',
        padding: '5px',
        marginTop: '5px',
        marginLeft: '10px',
    },
    iconDelete: {
        fontSize: '17px',
    },
    icon: {
        fontSize: '18px',
        marginRight: '10px',
    },
});

export default styles;
